export default __webpack_public_path__ + "static/WW_Black_Lodge_Tiled_FBx2-fd30b758cd5329ffc8fd48ee345894e2.gif";